import DrugListUpdateFields from './DrugListUpdateFields'

export default DrugListUpdateFields
